module.exports = __webpack_public_path__ + "static/media/lineVerticalSuperTeacher.1f95a967.svg";